/**
 * Calls formPostJWE to submit a JWE token to the AON Payment Security URL.
 * @param {string} jweToken - The JWE (nested JWT) token to submit.
 * @param {string} aonUrl - The AON Payment Security endpoint to POST to.
 * @param {string} tokenType - The token type identifying the application.
 * @param {string} [channelId] - The channel ID (default: 'digital-servicing').
 * @param {string} [language] - The language (default: 'en').
 * @param {string} [target] - The form target (default: '_self').
 */
import { getLanguageFromStorage } from 'syf-js-utilities';
import formPost from './form-post';
const submitJWEToAON = (samlToken, aonDestination) => {
    if (!samlToken)
        return;
    const params = {
        token: samlToken,
        'syf-channel-id': 'digital-servicing',
        tokenType: 'digitalservicing-payment-security',
        language: getLanguageFromStorage() ?? 'en'
    };
    formPost(aonDestination, params);
};
export default submitJWEToAON;
